import {
  DEFAULT_CREDIT_CARD_BRAND,
  CREDIT_CARD_BRANDS,
  FAST_PAYOUTS_STATUS,
} from '@/components/fast-payouts/consts'
import moment from 'moment'
import { MOMENT_FORMATS } from '@/localize.js'

export function getCreditCardImage ({ brand }) {
  const default_card = DEFAULT_CREDIT_CARD_BRAND

  return CREDIT_CARD_BRANDS[brand] || CREDIT_CARD_BRANDS[default_card]
}

export function fastPayoutsEnabledFor (status) {
  return [
    FAST_PAYOUTS_STATUS.AVAILABLE,
    FAST_PAYOUTS_STATUS.AVAILABLE_TOMORROW,
    FAST_PAYOUTS_STATUS.BLOCKED,
    FAST_PAYOUTS_STATUS.WRONG_DEBIT_CARD,
  ].includes(status)
}

export function formatDate (date) {
  return moment(date).format(MOMENT_FORMATS.MMM_D_YYYY)
}

export function formatTime (date) {
  return moment(date).format(MOMENT_FORMATS.hm_A)
}

export function getFormattedCardNumber (number) {
  if (number) {
    return `**** **** **** ${number}`
  }
  return ''
}

export function getFormattedBankAccountNumber (number) {
  if (number) {
    return `** **** **** **** ${number}`
  }
  return ''
}

export function fastPayoutLimitsShowEnabledFor (status) {
  return ![
    FAST_PAYOUTS_STATUS.HIDDEN,
    FAST_PAYOUTS_STATUS.MISSING_KYC,
  ].includes(status)
}
